import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO64 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK006-4.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO64
